<template>
  <div style="position: relative; height: 100%; width: 100%;" class="d-flex flex-column font-rubik">

    <v-card v-if="autoSelectingDocument" class="position-relative rounded-0" 
    style="z-index: 1000; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255, 255, 255, 0.9)"
    flat>
      <div class="d-flex flex-column align-center justify-center" style="height: 100vh;">
        <v-card elevation="0" class="pa-8 text-center" style="border-radius: 16px; background-color: white; max-width: 350px; border: 1px solid #eaeaea;">
          <v-img src="@/assets/images/uploading.svg" width="120" class="mx-auto mb-4" contain v-if="false"></v-img>
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" class="mx-auto mb-4" style="fill: #4dd453;">
            <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"></path>
          </svg>
          <h2 style="font-size: 22px; color: #333; font-weight: 600;" class="mb-3">Subiendo documento</h2>
          <p class="text-body-2 mb-4 text--secondary">Estamos procesando tu archivo. Por favor, espera un momento.</p>
          <v-progress-circular indeterminate color="primary" size="32" width="3" class="mb-2"></v-progress-circular>
        </v-card>
      </div>
    </v-card>


    <!-- Sección de generación -->
    <v-card class="position-relative rounded-0" flat>

      <div v-if="!showFileUploader && !showTextUploader && !showImageUploader && !showQRUploader" 
       style="max-width: 650px;"
        class="mt-12  d-flex flex-column text-center align-center mx-auto pt-12">
        <h2 style="font-size: 24px;">Genera</h2>
        <span style="font-size: 16px;" class="my-2">Convierte cualquier contenido en resumen, una lección con preguntas
          de prueba,
          tarjetas didácticas, notas de estudio y más.</span>
      </div>

      <div v-if="!showFileUploader && !showTextUploader && !showImageUploader && !showQRUploader" class="creation-options ">
        <div class="d-flex flex-column mx-auto" style="max-width: 450px;">
          <v-card 
          v-if="false"
            @click="showTextUploader = true"
            class="creation-card d-flex" elevation="0">
            <div class="creation-card-inner">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                width="40" height="40" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512"
                xml:space="preserve" class="hovered-paths mb-1 ml-1">
                <g>
                  <path
                    d="M88.082 64.001h288c17.672 0 32 14.328 32 32v384c0 17.672-14.328 32-32 32h-288c-17.672 0-32-14.328-32-32v-384c0-17.672 14.328-32 32-32z"
                    style="" fill="#bd6428" data-original="#bd6428" class=""></path>
                  <path
                    d="M96.082 480.001c-4.416 0-8-3.584-8-8v-368c0-4.416 3.584-8 8-8h272c4.416 0 8 3.584 8 8v288l-88 88h-192z"
                    style="" fill="#f5f6f6" data-original="#f5f6f6" class="hovered-path"></path>
                  <path d="M152.082 96.001h-16v-16c0-8.84 7.16-16 16-16v32z" style="" fill="#ae5c26"
                    data-original="#ae5c26" class=""></path>
                  <path
                    d="M140.082 224.001h184c6.624 0 12 5.376 12 12s-5.376 12-12 12h-184c-6.624 0-12-5.376-12-12s5.376-12 12-12zM140.082 272.001h184c6.624 0 12 5.376 12 12s-5.376 12-12 12h-184c-6.624 0-12-5.376-12-12s5.376-12 12-12zM140.082 320.001h104c6.624 0 12 5.376 12 12s-5.376 12-12 12h-104c-6.624 0-12-5.376-12-12s5.376-12 12-12zM180.082 160.001h104c6.624 0 12 5.376 12 12s-5.376 12-12 12h-104c-6.624 0-12-5.376-12-12s5.376-12 12-12z"
                    style="" fill="#9ba7af" data-original="#9ba7af" class=""></path>
                  <path d="M376.082 392.001h-80c-4.416 0-8 3.584-8 8v80l88-88z" style="" fill="#cecece"
                    data-original="#cecece"></path>
                  <path
                    d="M64.082 88.001c4.416 0 8 3.584 8 8v264c0 4.416-3.584 8-8 8s-8-3.584-8-8v-264c0-4.416 3.584-8 8-8z"
                    style="" fill="#d17f4d" data-original="#d17f4d" class=""></path>
                  <path
                    d="M280.082 408.001v16c0 4.416-3.584 8-8 8s-8 3.584-8 8-3.584 8-8 8h-8c-4.416 0-8 3.584-8 8s-3.584 8-8 8h-144v8c0 4.416 3.584 8 8 8h192v-80c-4.416 0-8 3.584-8 8zM368.082 96.001h-232c.128 2.4.128 4.8 0 7.2-.44 8.824 6.352 16.336 15.176 16.776.28.016.552.024.824.024h192c8.84 0 16 7.16 16 16v24c0 8.84 7.16 16 16 16v-72c0-4.416-3.576-8-8-8z"
                    style="" fill="#e9e9e9" data-original="#e9e9e9" class=""></path>
                  <path
                    d="M284.802 45.121a24.714 24.714 0 0 1-14.32-16c-6.184-21.208-28.392-33.384-49.6-27.2a39.983 39.983 0 0 0-27.2 27.2 24.714 24.714 0 0 1-14.32 16l-17.2 6.88a15.998 15.998 0 0 0-10.08 14.8v29.2c0 8.84 7.16 16 16 16h128c8.84 0 16-7.16 16-16v-29.2a15.998 15.998 0 0 0-10.08-14.8l-17.2-6.88zm-52.72 10.88c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                    style="" fill="#9ba7af" data-original="#9ba7af" class=""></path>
                  <path
                    d="M288.082 64.001c-4.416 0-8 3.584-8 8s-3.584 8-8 8h-16c-4.416 0-8 3.584-8 8s-3.584 8-8 8h-88c0 8.84 7.16 16 16 16h128c8.84 0 16-7.16 16-16v-32h-24z"
                    style="" fill="#72818b" data-original="#72818b" class=""></path>
                  <path
                    d="M201.122 40.001c-4.416.144-8.112-3.328-8.248-7.744a8.24 8.24 0 0 1 .248-2.256c4.584-17.744 20.64-30.104 38.96-30 4.416 0 8 3.584 8 8s-3.584 8-8 8c-10.96-.016-20.544 7.392-23.28 18a7.996 7.996 0 0 1-7.68 6z"
                    style="" fill="#afbabf" data-original="#afbabf" class=""></path>
                  <path
                    d="M376.082 80.001h-32c-8.84 0-16-7.16-16-16h-16v32h56c4.416 0 8 3.584 8 8v288l-88 88h-192c0 8.84 7.16 16 16 16h194.72a31.998 31.998 0 0 0 22.64-9.36l53.28-53.28a31.998 31.998 0 0 0 9.36-22.64V96.001c0-8.832-7.16-16-16-16z"
                    style="" fill="#a35623" data-original="#a35623" class=""></path>
                  <path
                    d="M376.082 263.361v80.64c0 4.416 3.584 8 8 8s8-3.584 8-8v-8c0-4.416 3.584-8 8-8s8-3.584 8-8v-88l-32 31.36z"
                    style="" fill="#a35623" data-original="#a35623" class=""></path>
                  <path
                    d="M400.082 312.001a7.992 7.992 0 0 1-5.68-2.32c-11.928-11.96-11.928-31.32 0-43.28l32-32c5.72-5.712 5.728-14.984.016-20.704l-.016-.016c-2.872-3.352-2.48-8.408.872-11.28a7.994 7.994 0 0 1 10.408 0c11.928 11.96 11.928 31.32 0 43.28l-32 32c-5.72 5.712-5.728 14.984-.016 20.704l.016.016c3.096 3.152 3.04 8.216-.112 11.312a8.002 8.002 0 0 1-5.488 2.288z"
                    style="" fill="#afbabf" data-original="#afbabf" class=""></path>
                  <path
                    d="M248.082 344.001c-4.416.008-8.008-3.56-8.024-7.976 0-.88.136-1.752.424-2.584l8-24a8.004 8.004 0 0 1 10.12-5.08 8.004 8.004 0 0 1 5.08 10.12l-2.96 8.8 8.8-2.96a8.004 8.004 0 0 1 10.12 5.08 8.004 8.004 0 0 1-5.08 10.12l-24 8a7.933 7.933 0 0 1-2.48.48z"
                    style="" fill="#35363e" data-original="#35363e" class=""></path>
                  <path
                    d="m261.762 277.681 44.72 44.72a7.996 7.996 0 0 0 11.28 0l114.32-114.4-56-56-114.32 114.32c-3.136 3.112-3.16 8.176-.048 11.312.024.016.032.032.048.048z"
                    style="" fill="#4cd553" data-original="#3cb54a" class="" opacity="1"></path>
                  <path
                    d="m420.082 196.001-93.68 93.68a7.996 7.996 0 0 1-11.28 0l-11.52-11.52a7.994 7.994 0 0 0-10.32-.96c-2.96 2.96-5.76 5.52-14.8-3.52l-6.4-6.4a7.994 7.994 0 0 0-10.32-.96 7.996 7.996 0 0 0 0 11.28l38.32 38.4 6.32 6.32a7.996 7.996 0 0 0 11.28 0l114.4-114.32-12-12z"
                    style="" fill="#37bb45" data-original="#0e9347" class="" opacity="1"></path>
                  <path
                    d="m376.082 152.001 56 56 12.4-12.4c15.248-15.552 15.248-40.448 0-56-15.552-15.248-40.448-15.248-56 0l-12.4 12.4zM245.762 309.681l28.72 28.72a7.996 7.996 0 0 0 11.28 0l18.32-18.4-40-40-18.32 18.32c-3.136 3.112-3.16 8.176-.048 11.312.024.016.032.032.048.048z"
                    style="" fill="#595a66" data-original="#595a66" class=""></path>
                  <path
                    d="m306.402 322.321-2.32-2.32-18.32 18.32a7.996 7.996 0 0 1-11.28 0l-2.4-2.32-21.76 7.28a7.887 7.887 0 0 1-2.24.72h36.48a48.958 48.958 0 0 0 21.92-5.2l14.56-7.28a48.878 48.878 0 0 0 12.64-9.12 35.431 35.431 0 0 1 25.12-10.4h1.28c8.84 0 16-7.16 16-16v-32l-58.32 58.32c-3.112 3.136-8.176 3.16-11.312.048l-.048-.048z"
                    style="" fill="#e9e9e9" data-original="#e9e9e9" class=""></path>
                  <path
                    d="M264.082 280.001c-4.416 4.392-4.44 11.536-.048 15.952l.048.048 16 16c4.416 4.136 4.648 11.072.512 15.488-.16.176-.336.344-.512.512l-8 8 2.32 2.32a7.996 7.996 0 0 0 11.28 0l18.4-18.32-40-40z"
                    style="" fill="#35363e" data-original="#35363e" class=""></path>
                  <path
                    d="M368.082 200.001c-4.416.024-8.024-3.536-8.048-7.952a7.975 7.975 0 0 1 2.368-5.728l32-32c3.352-2.872 8.408-2.48 11.28.872a7.994 7.994 0 0 1 0 10.408l-32 32a8.01 8.01 0 0 1-5.6 2.4z"
                    style="" fill="#6fe27c" data-original="#89c763" class="" opacity="1"></path>
                  <path
                    d="m397.762 173.681 8-8c2.872-3.352 2.48-8.408-.872-11.28a7.994 7.994 0 0 0-10.408 0l-8 8 11.28 11.28z"
                    style="" fill="#6f707e" data-original="#6f707e" class=""></path>
                  <path d="m432.082 208.001 8-8a8.887 8.887 0 0 0-.72-12 7.996 7.996 0 0 0-11.28 0l-8 8 12 12z" style=""
                    fill="#35363e" data-original="#35363e" class=""></path>
                </g>
              </svg>
            </div>
            <div class="d-flex flex-column">
              <span>Texto</span>
              <span style="font-size: 12px;" class="font-weight-regular font-rubik">Copia o escribe tu texto.</span>
            </div>
          </v-card>

          <v-card @click="showFileUploader = true" class="creation-card d-flex" elevation="0">
            <div class="creation-card-inner">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                width="40" height="40" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512"
                xml:space="preserve" class="hovered-paths mb-1 ml-1">
                <g>
                  <path
                    d="m464 288-32-104H80L48 288h104c4.416 0 8 3.584 8 8v48c0 4.416 3.584 8 8 8h176c4.416 0 8-3.584 8-8v-48c0-4.416 3.584-8 8-8h104z"
                    style="" fill="#7f4122" data-original="#7f4122"></path>
                  <path
                    d="M459.84 170.48A15.99 15.99 0 0 0 444.88 160H67.12a16.008 16.008 0 0 0-15.04 10.48L0 312h160v-16c0-4.416-3.584-8-8-8H48l32-104h352l32 104H360c-4.416 0-8 3.584-8 8v16h160l-52.16-141.52z"
                    style="" fill="#a35425" data-original="#a35425" class=""></path>
                  <path
                    d="M352 312v32c0 4.416-3.584 8-8 8H168c-4.416 0-8-3.584-8-8v-32H0v112c0 13.256 10.744 24 24 24h464c13.256 0 24-10.744 24-24V312H352z"
                    style="" fill="#c97629" data-original="#c97629" class=""></path>
                  <path d="M160 328h192v16c0 4.416-3.584 8-8 8H168c-4.416 0-8-3.584-8-8v-16z" style="" fill="#a35425"
                    data-original="#a35425" class=""></path>
                  <path
                    d="M496 352v72c0 4.416-3.584 8-8 8H40c-8.84 0-16 7.16-16 16h464c13.256 0 24-10.744 24-24v-88c-8.84 0-16 7.16-16 16z"
                    style="" fill="#b06328" data-original="#b06328" class="hovered-path"></path>
                  <path
                    d="M0 312h160c0 8.84-7.16 16-16 16H16c-8.84 0-16-7.16-16-16zM352 312h160c0 8.84-7.16 16-16 16H368c-8.84 0-16-7.16-16-16z"
                    style="" fill="#da8c36" data-original="#da8c36" class=""></path>
                  <path d="M431.92 184H80.08L48 288h32l8-48h336l8 48h32z" style="" fill="#73371b"
                    data-original="#73371b" class=""></path>
                  <circle cx="256" cy="168" r="104" style="" fill="#3cb54a" data-original="#3cb54a" class=""
                    opacity="1">
                  </circle>
                  <path
                    d="M306.24 155.68c-6.792-5.656-16.88-4.736-22.536 2.048-.008.008-.016.024-.024.032L272 171.84V120c0-8.84-7.16-16-16-16s-16 7.16-16 16v51.84l-11.68-14.08c-5.408-6.992-15.456-8.272-22.448-2.864s-8.272 15.456-2.864 22.448c.24.312.488.608.752.904l40 48c5.664 6.784 15.752 7.688 22.536 2.024a16.125 16.125 0 0 0 2.024-2.024l40-48c5.656-6.792 4.736-16.88-2.048-22.536-.008-.016-.024-.024-.032-.032-.032z"
                    style="" fill="#e6f2e4" data-original="#ffffff" class="" opacity="1"></path>
                  <path
                    d="M256 272c-4.416 0-8-3.584-8-8s3.584-8 8-8c48.6 0 88-39.4 88-88 0-4.416 3.584-8 8-8s8 3.584 8 8c0 57.44-46.56 104-104 104z"
                    style="" fill="#0e9347" data-original="#0e9347" class="" opacity="1"></path>
                  <path
                    d="M256 64c4.416 0 8 3.584 8 8s-3.584 8-8 8c-48.6 0-88 39.4-88 88 0 4.416-3.584 8-8 8s-8-3.584-8-8c0-57.44 46.56-104 104-104z"
                    style="" fill="#9eebac" data-original="#89c763" class="" opacity="1"></path>
                </g>
              </svg>
            </div>
            <div class="d-flex flex-column">
              <span>Subir Documento PDF</span>
              <span style="font-size: 12px;" class="font-weight-regular font-rubik">Sube Apuntes, PowerPoints, PDFs,
                Words, etc.</span>
            </div>
          </v-card>

      
          <v-card 
          v-if="false"
          @click="showImageUploader=true"
          class="creation-card d-flex" elevation="0">
            <div class="creation-card-inner">
             <images :width="40" :height="40" />  
            </div>
            <div class="d-flex flex-column">
              <span>Sube imágenes</span>
              <span style="font-size: 12px;" class="font-weight-regular font-rubik">Sube imágenes de tus apuntes,
                cuadernos o libros.</span>
            </div>
          </v-card>

          <v-card 
          @click="showQRUploader=true"
          class="creation-card d-flex" elevation="0">
            <div class="creation-card-inner">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                width="40" height="40" x="0" y="0" viewBox="0 0 497 497" style="enable-background:new 0 0 512 512"
                xml:space="preserve" class="hovered-paths mb-1 ml-1">
                <g>
                  <path fill="#9ba7af"
                    d="M290.418 497H86.309c-27.574 0-49.928-22.353-49.928-49.928V49.928C36.381 22.353 58.735 0 86.309 0h204.109c27.574 0 49.928 22.353 49.928 49.928v397.144C340.345 474.647 317.992 497 290.418 497z"
                    opacity="1" data-original="#8ebac5" class=""></path>
                  <path fill="#72818b"
                    d="M290.417 0h-26c27.574 0 49.928 22.354 49.928 49.928v397.145c0 27.574-22.353 49.928-49.928 49.928h26c27.574 0 49.928-22.353 49.928-49.928V49.928C340.345 22.354 317.992 0 290.417 0z"
                    opacity="1" data-original="#7ca1b1" class=""></path>
                  <path fill="#f2f7f7"
                    d="M288.667 26h-37.099c-4.689 0-8.99 2.606-11.159 6.763l-7.174 13.743a12.258 12.258 0 0 1-10.865 6.585h-68.011a12.255 12.255 0 0 1-10.865-6.585l-7.174-13.743A12.588 12.588 0 0 0 125.161 26H88.06c-14.182 0-25.678 11.497-25.678 25.678v393.644C62.381 459.503 73.878 471 88.06 471h200.607c14.182 0 25.678-11.497 25.678-25.678V51.678c0-14.181-11.496-25.678-25.678-25.678z"
                    opacity="1" data-original="#f2f7f7" class=""></path>
                  <path fill="#deecf1"
                    d="M118.383 53.091h35.975a12.256 12.256 0 0 1-10.866-6.585l-7.174-13.743A12.588 12.588 0 0 0 125.159 26H90.663a16.06 16.06 0 0 1 10.413 8.166l6.441 12.339a12.257 12.257 0 0 0 10.866 6.586z"
                    opacity="1" data-original="#deecf1" class=""></path>
                  <path fill="#72818b"
                    d="M203.725 33.5h-30.723c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h30.723a7.5 7.5 0 0 1 0 15z"
                    opacity="1" data-original="#7ca1b1" class=""></path>
                  <path fill="#deecf1"
                    d="M288.667 26h-37.099c14.182 0 26.802 11.497 26.802 25.678v81.83c0 8.169-6.622 14.791-14.791 14.791h-26.766c-9.43 0-17.86 5.86-21.15 14.7l-13.714 36.914a14.523 14.523 0 0 1-13.614 9.465h-43.172c-12.758 0-23.1 10.342-23.1 23.1v134.64c0 12.758 11.235 18.963 23.993 18.963l76.186 1.758 56.129-198.902V445.32c0 14.182-11.497 25.678-25.678 25.678h35.975c14.182 0 25.678-11.497 25.678-25.678V51.678C314.345 37.497 302.849 26 288.667 26z"
                    opacity="1" data-original="#deecf1" class=""></path>
                  <path fill="#35363e"
                    d="M183.665 390.217H125.12c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h58.545c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z"
                    opacity="1" data-original="#5f8189" class=""></path>
                  <path fill="#595a66"
                    d="M445.596 232.48v134.64c0 12.76-10.34 23.1-23.1 23.1h-238.83c-12.76 0-23.1-10.34-23.1-23.1V232.48c0-12.76 10.34-23.1 23.1-23.1h43.61c5.8 0 11-3.61 13.02-9.05l13.87-37.33a22.564 22.564 0 0 1 21.15-14.7h55.53c9.43 0 17.87 5.86 21.15 14.7l13.87 37.33c2.02 5.44 7.22 9.05 13.02 9.05h43.61c12.76 0 23.1 10.34 23.1 23.1z"
                    opacity="1" data-original="#678d98" class=""></path>
                  <g fill="#5f8189">
                    <path
                      d="M378.886 209.38h-37.6c-6.35 0-12.02-3.94-14.23-9.89L313.496 163a22.564 22.564 0 0 0-21.15-14.7h38.5c9.43 0 17.87 5.86 21.15 14.7l13.87 37.33c2.02 5.44 7.22 9.05 13.02 9.05zM422.499 209.382h-38.503c12.756 0 23.097 10.341 23.097 23.097V367.12c0 12.756-10.341 23.097-23.097 23.097h38.503c12.756 0 23.097-10.341 23.097-23.097V232.479c0-12.756-10.341-23.097-23.097-23.097z"
                      fill="#35363e" opacity="1" data-original="#5f8189" class=""></path>
                  </g>
                  <circle cx="303.082" cy="291.609" r="61.902" fill="#6fe07c" opacity="1" data-original="#bec6ed"
                    class=""></circle>
                  <path fill="#4bd151"
                    d="M303.082 229.707a62.07 62.07 0 0 0-13 1.379c27.944 5.974 48.902 30.796 48.902 60.523s-20.958 54.549-48.902 60.523a62.136 62.136 0 0 0 13 1.379c34.187 0 61.902-27.714 61.902-61.901-.001-34.189-27.715-61.903-61.902-61.903z"
                    opacity="1" data-original="#a2aee6" class=""></path>
                  <path fill="#f2f7f7"
                    d="M303.082 327.511c-19.796 0-35.902-16.105-35.902-35.902 0-19.796 16.105-35.901 35.902-35.901 19.796 0 35.901 16.105 35.901 35.901s-16.105 35.902-35.901 35.902z"
                    opacity="1" data-original="#f2f7f7" class=""></path>
                  <path fill="#deecf1"
                    d="M303.082 255.707c-4.068 0-7.976.69-11.624 1.942 14.106 4.842 24.277 18.231 24.277 33.959 0 15.729-10.171 29.118-24.277 33.96a35.744 35.744 0 0 0 11.624 1.942c19.796 0 35.901-16.105 35.901-35.902 0-19.796-16.105-35.901-35.901-35.901z"
                    opacity="1" data-original="#deecf1" class=""></path>
                  <path fill="#f2f7f7"
                    d="M325.396 182.75c0 2.21-.96 4.21-2.49 5.57a7.424 7.424 0 0 1-5.01 1.93h-29.63c-4.14 0-7.5-3.36-7.5-7.5 0-4.15 3.36-7.5 7.5-7.5h29.63c.05 0 .11 0 .16.01a7.48 7.48 0 0 1 7.34 7.49z"
                    opacity="1" data-original="#f2f7f7" class=""></path>
                  <path fill="#deecf1"
                    d="M325.396 182.75c0 2.21-.96 4.21-2.49 5.57l-4.85-13.06a7.48 7.48 0 0 1 7.34 7.49z" opacity="1"
                    data-original="#deecf1" class=""></path>
                  <path fill="#6fe07c"
                    d="M453.119 93.239h-33.06c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h33.06c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z"
                    opacity="1" data-original="#bec6ed" class=""></path>
                  <path fill="#4bd151"
                    d="M411.098 51.773a7.501 7.501 0 0 1-4.587-13.439l19.612-15.129a7.501 7.501 0 0 1 9.163 11.877l-19.612 15.129a7.46 7.46 0 0 1-4.576 1.562zM430.7 149.716c-1.6 0-3.211-.509-4.576-1.562l-19.612-15.129a7.5 7.5 0 1 1 9.163-11.877l19.612 15.129a7.5 7.5 0 0 1-4.587 13.439z"
                    opacity="1" data-original="#a2aee6" class=""></path>
                </g>
              </svg>
            </div>
            <div class="d-flex flex-column">
              <span>Fotos con móvil</span>
              <span style="font-size: 12px;" class="font-weight-regular font-rubik">Escanea QR y toma fotos con tu móvil.</span>
            </div>
          </v-card>

          <v-card
          v-if="false && !$vuetify.breakpoint.xs"
          @click="showQRUploader=true"
          class="creation-card d-flex" elevation="0">
            <div class="creation-card-inner">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                width="40" height="40" x="0" y="0" viewBox="0 0 497 497" style="enable-background:new 0 0 512 512"
                xml:space="preserve" class="hovered-paths mb-1 ml-1">
                <g>
                  <path fill="#9ba7af"
                    d="M290.418 497H86.309c-27.574 0-49.928-22.353-49.928-49.928V49.928C36.381 22.353 58.735 0 86.309 0h204.109c27.574 0 49.928 22.353 49.928 49.928v397.144C340.345 474.647 317.992 497 290.418 497z"
                    opacity="1" data-original="#8ebac5" class=""></path>
                  <path fill="#72818b"
                    d="M290.417 0h-26c27.574 0 49.928 22.354 49.928 49.928v397.145c0 27.574-22.353 49.928-49.928 49.928h26c27.574 0 49.928-22.353 49.928-49.928V49.928C340.345 22.354 317.992 0 290.417 0z"
                    opacity="1" data-original="#7ca1b1" class=""></path>
                  <path fill="#f2f7f7"
                    d="M288.667 26h-37.099c-4.689 0-8.99 2.606-11.159 6.763l-7.174 13.743a12.258 12.258 0 0 1-10.865 6.585h-68.011a12.255 12.255 0 0 1-10.865-6.585l-7.174-13.743A12.588 12.588 0 0 0 125.161 26H88.06c-14.182 0-25.678 11.497-25.678 25.678v393.644C62.381 459.503 73.878 471 88.06 471h200.607c14.182 0 25.678-11.497 25.678-25.678V51.678c0-14.181-11.496-25.678-25.678-25.678z"
                    opacity="1" data-original="#f2f7f7" class=""></path>
                  <path fill="#deecf1"
                    d="M118.383 53.091h35.975a12.256 12.256 0 0 1-10.866-6.585l-7.174-13.743A12.588 12.588 0 0 0 125.159 26H90.663a16.06 16.06 0 0 1 10.413 8.166l6.441 12.339a12.257 12.257 0 0 0 10.866 6.586z"
                    opacity="1" data-original="#deecf1" class=""></path>
                  <path fill="#72818b"
                    d="M203.725 33.5h-30.723c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h30.723a7.5 7.5 0 0 1 0 15z"
                    opacity="1" data-original="#7ca1b1" class=""></path>
                  <path fill="#deecf1"
                    d="M288.667 26h-37.099c14.182 0 26.802 11.497 26.802 25.678v81.83c0 8.169-6.622 14.791-14.791 14.791h-26.766c-9.43 0-17.86 5.86-21.15 14.7l-13.714 36.914a14.523 14.523 0 0 1-13.614 9.465h-43.172c-12.758 0-23.1 10.342-23.1 23.1v134.64c0 12.758 11.235 18.963 23.993 18.963l76.186 1.758 56.129-198.902V445.32c0 14.182-11.497 25.678-25.678 25.678h35.975c14.182 0 25.678-11.497 25.678-25.678V51.678C314.345 37.497 302.849 26 288.667 26z"
                    opacity="1" data-original="#deecf1" class=""></path>
                  <path fill="#35363e"
                    d="M183.665 390.217H125.12c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h58.545c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z"
                    opacity="1" data-original="#5f8189" class=""></path>
                  <path fill="#595a66"
                    d="M445.596 232.48v134.64c0 12.76-10.34 23.1-23.1 23.1h-238.83c-12.76 0-23.1-10.34-23.1-23.1V232.48c0-12.76 10.34-23.1 23.1-23.1h43.61c5.8 0 11-3.61 13.02-9.05l13.87-37.33a22.564 22.564 0 0 1 21.15-14.7h55.53c9.43 0 17.87 5.86 21.15 14.7l13.87 37.33c2.02 5.44 7.22 9.05 13.02 9.05h43.61c12.76 0 23.1 10.34 23.1 23.1z"
                    opacity="1" data-original="#678d98" class=""></path>
                  <g fill="#5f8189">
                    <path
                      d="M378.886 209.38h-37.6c-6.35 0-12.02-3.94-14.23-9.89L313.496 163a22.564 22.564 0 0 0-21.15-14.7h38.5c9.43 0 17.87 5.86 21.15 14.7l13.87 37.33c2.02 5.44 7.22 9.05 13.02 9.05zM422.499 209.382h-38.503c12.756 0 23.097 10.341 23.097 23.097V367.12c0 12.756-10.341 23.097-23.097 23.097h38.503c12.756 0 23.097-10.341 23.097-23.097V232.479c0-12.756-10.341-23.097-23.097-23.097z"
                      fill="#35363e" opacity="1" data-original="#5f8189" class=""></path>
                  </g>
                  <circle cx="303.082" cy="291.609" r="61.902" fill="#6fe07c" opacity="1" data-original="#bec6ed"
                    class=""></circle>
                  <path fill="#4bd151"
                    d="M303.082 229.707a62.07 62.07 0 0 0-13 1.379c27.944 5.974 48.902 30.796 48.902 60.523s-20.958 54.549-48.902 60.523a62.136 62.136 0 0 0 13 1.379c34.187 0 61.902-27.714 61.902-61.901-.001-34.189-27.715-61.903-61.902-61.903z"
                    opacity="1" data-original="#a2aee6" class=""></path>
                  <path fill="#f2f7f7"
                    d="M303.082 327.511c-19.796 0-35.902-16.105-35.902-35.902 0-19.796 16.105-35.901 35.902-35.901 19.796 0 35.901 16.105 35.901 35.901s-16.105 35.902-35.901 35.902z"
                    opacity="1" data-original="#f2f7f7" class=""></path>
                  <path fill="#deecf1"
                    d="M303.082 255.707c-4.068 0-7.976.69-11.624 1.942 14.106 4.842 24.277 18.231 24.277 33.959 0 15.729-10.171 29.118-24.277 33.96a35.744 35.744 0 0 0 11.624 1.942c19.796 0 35.901-16.105 35.901-35.902 0-19.796-16.105-35.901-35.901-35.901z"
                    opacity="1" data-original="#deecf1" class=""></path>
                  <path fill="#f2f7f7"
                    d="M325.396 182.75c0 2.21-.96 4.21-2.49 5.57a7.424 7.424 0 0 1-5.01 1.93h-29.63c-4.14 0-7.5-3.36-7.5-7.5 0-4.15 3.36-7.5 7.5-7.5h29.63c.05 0 .11 0 .16.01a7.48 7.48 0 0 1 7.34 7.49z"
                    opacity="1" data-original="#f2f7f7" class=""></path>
                  <path fill="#deecf1"
                    d="M325.396 182.75c0 2.21-.96 4.21-2.49 5.57l-4.85-13.06a7.48 7.48 0 0 1 7.34 7.49z" opacity="1"
                    data-original="#deecf1" class=""></path>
                  <path fill="#6fe07c"
                    d="M453.119 93.239h-33.06c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h33.06c4.142 0 7.5 3.357 7.5 7.5s-3.358 7.5-7.5 7.5z"
                    opacity="1" data-original="#bec6ed" class=""></path>
                  <path fill="#4bd151"
                    d="M411.098 51.773a7.501 7.501 0 0 1-4.587-13.439l19.612-15.129a7.501 7.501 0 0 1 9.163 11.877l-19.612 15.129a7.46 7.46 0 0 1-4.576 1.562zM430.7 149.716c-1.6 0-3.211-.509-4.576-1.562l-19.612-15.129a7.5 7.5 0 1 1 9.163-11.877l19.612 15.129a7.5 7.5 0 0 1-4.587 13.439z"
                    opacity="1" data-original="#a2aee6" class=""></path>
                </g>
              </svg>
            </div>
            <div class="d-flex flex-column">
              <span>Tomar foto</span>
              <span style="font-size: 12px;" class="font-weight-regular font-rubik">Escanea QR y toma fotos con tu móvil de tus
                libros / apuntes</span>
            </div>
          </v-card>

        </div>
      </div>
      <div v-else-if="showFileUploader" style="position: relative;">
        <FileUploader @back="showFileUploader = false" :subjectId="subjectId" 
        @disable-auto-selecting-document="$emit('update:autoSelectingDocument', false)"
        />
      </div>
      <div v-else-if="showImageUploader" style="position: relative;">
        <ImageUploader @back="showImageUploader = false" :subjectId="subjectId" 
        @disable-auto-selecting-document="$emit('update:autoSelectingDocument', false)"
        />
      </div>
      <div v-else-if="showTextUploader" style="position: relative;">
        <TextEditor @back="showTextUploader = false" :subjectId="subjectId" 
        @disable-auto-selecting-document="$emit('update:autoSelectingDocument', false)"
        />
      </div>
      <div v-else-if="showQRUploader" style="position: relative;">
        <QRUploader @back="showQRUploader = false" :subjectId="subjectId" 
        @disable-auto-selecting-document="$emit('update:autoSelectingDocument', false)"
        />
      </div>
    </v-card>
  </div>
</template>


<script>
import FileUploader from './components/FileUploader.vue'
import TextEditor from './components/TextEditor.vue'
import ImageUploader from './components/ImageUploader.vue'
import QRUploader from './components/QRUploader.vue'
import Images from '@/assets/icons/Images.vue'

export default {
  name: 'Upload',
  components: {
    FileUploader,
    TextEditor,
    ImageUploader,
    QRUploader,
    Images
  },
  props: {
    subjectId: {
      type: [Number, String],
      default: null
    },
    autoSelectingDocument: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showFileUploader: false,
      showTextUploader: false,
      showImageUploader: false,
      showQRUploader: false,
      droppedFiles: null
    }
  },
  mounted() {
    // Escuchar el evento global de archivos arrastrados
    this.$root.$on('files-dropped', this.handleDroppedFiles);
  },
  beforeDestroy() {
    // Eliminar el listener al destruir el componente
    this.$root.$off('files-dropped', this.handleDroppedFiles);
  },
  methods: {
    handleDroppedFiles(data) {
      console.log('handleDroppedFiles recibido:', data);
      
      if (!data || !data.files || data.files.length === 0) {
        console.error('No hay archivos válidos en los datos recibidos');
        return;
      }
      
      // Analizar mejor el tipo de archivos
      console.log('Tipo de files:', typeof data.files);
      console.log('¿Es array?', Array.isArray(data.files));
      console.log('¿Es FileList?', data.files instanceof FileList);
      console.log('Número de archivos:', data.files.length);
      
      // Comprobaciones adicionales
      const fileArray = Array.from(data.files);
      const fileTypes = fileArray.map(f => f.type);
      console.log('Tipos de archivos recibidos:', fileTypes);
      
      // Guardar los archivos soltados
      this.droppedFiles = data.files;
      
      // Determinar si son imágenes analizando cada archivo
      const areAllImages = fileArray.every(file => file.type.startsWith('image/'));
      const areAnyImages = fileArray.some(file => file.type.startsWith('image/'));
      const hasPDF = fileArray.some(file => file.type.includes('pdf'));
      
      console.log('¿Son todas imágenes?', areAllImages);
      console.log('¿Hay alguna imagen?', areAnyImages);
      console.log('¿Hay algún PDF?', hasPDF);
      
      // Lógica mejorada para determinar qué tipo de uploader mostrar
      if (hasPDF || (!areAnyImages && (data.isPDF || fileArray.some(file => file.type.includes('pdf') || file.type.includes('document'))))) {
        // Si hay un PDF o documento, mostrar el uploader de archivos
        console.log('Detectado como PDF/documento - mostrando FileUploader');
        this.showFileUploader = true;
        this.showTextUploader = false;
        this.showImageUploader = false;
        
        // En el siguiente tick, pasar los archivos al FileUploader
        setTimeout(() => {
          // Buscar el componente en los hijos usando la recursión
          const findComponentRecursively = (children) => {
            for (const child of children) {
              if (child.$options && child.$options.name === 'FileUploader') {
                return child;
              }
              if (child.$children && child.$children.length) {
                const found = findComponentRecursively(child.$children);
                if (found) return found;
              }
            }
            return null;
          };
          
          const fileUploaderComponent = findComponentRecursively(this.$children);
          
          if (fileUploaderComponent) {
            console.log('FileUploader encontrado, procesando archivos...');
            fileUploaderComponent.onFileSelected(data.files);
          } else {
            console.error('No se pudo encontrar el componente FileUploader');
          }
        }, 500); // Aumentar tiempo para asegurar que el componente se monte
      } else if (areAnyImages || data.areImages) {
        console.log('Detectado como imágenes - mostrando ImageUploader');
        this.$emit('update:autoSelectingDocument', false);

        // Si son imágenes, mostrar el uploader de imágenes
        this.showFileUploader = false;
        this.showTextUploader = false;
        this.showImageUploader = true;
        
        // Dar tiempo suficiente para que se monte el componente ImageUploader
        setTimeout(() => {
          // Buscar el componente en los hijos usando la recursión
          const findComponentRecursively = (children) => {
            for (const child of children) {
              if (child.$options && child.$options.name === 'ImageUploader') {
                return child;
              }
              if (child.$children && child.$children.length) {
                const found = findComponentRecursively(child.$children);
                if (found) return found;
              }
            }
            return null;
          };
          
          const imageUploaderComponent = findComponentRecursively(this.$children);
          
          if (imageUploaderComponent) {
            console.log('ImageUploader encontrado, procesando imágenes...');
            // Pasar directamente los archivos para evitar problemas de conversión
            imageUploaderComponent.onImagesSelected(data.files);
          } else {
            console.error('No se pudo encontrar el componente ImageUploader');
          }
        }, 500); // Aumentar tiempo para asegurar que el componente se monte
      } else {
        console.log('Tipo de archivo no reconocido:', fileTypes);
      }
    }
  }
}
</script>



<style scoped>
.creation-options {
  margin-top: 20px;
}

.creation-card {
  border-radius: 16px !important;
  overflow: hidden;
  transition: transform 0.2s ease;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  max-width: 450px;
  border: 1px solid #E3E5EB;
}

.creation-card:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.creation-card span {
  font-size: 1rem;
  font-weight: 600;
  margin-left: 10px;
}

.creation-card-inner {
  background-color: #eaf7e9;
  height: 64px;
  width: 64px;
  text-align: center;
  border-radius: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.creation-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  color: #5271ff !important;
  max-height: 36px !important;
}

.v-btn.primary-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 800 !important;
  font-size: 0.9rem !important;
  border-radius: 13px !important;
  transition: filter 0.2s ease, transform 0.1s ease !important;
  height: 38px !important;
  max-height: 38px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  border: 2px solid #4dd453 !important;
  background-color: #4dd453 !important;
  box-shadow: 0 4px 0 #42b848 !important;
  color: white;
}
</style>